import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Tooltip from 'components/tooltip';

const OveragesTooltip = () => {
    return (
        <Tooltip.Root>
            <Tooltip.Trigger>
                <FontAwesomeIcon icon={faCircleQuestion} size="sm" className="text-gray-400" />
                <span className="sr-only">More information</span>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse>
                    <Tooltip.Arrow inverse />
                    <p>
                        Overage fees are additional charges that apply to your monthly bill if you
                        exceed the number of contacts allowed in your tier.
                    </p>
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

export { OveragesTooltip };
